import {
	type Deal,
	useCheckoutFormState,
} from "../../hooks/useCheckoutFormState";
import { useStorefrontSettingsState } from "../../hooks/useStorefrontSettingsState";
import { useTranslate } from "../../hooks/useTranslate/useTranslate";
import { cn } from "../../lib/utils";
import { Label } from "../ui/label";
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../ui/select";

export type SelectDealProps = {
	disabled?: boolean;
	className?: string;
	hasNew?: boolean;
	hasNotSelected?: boolean;
	onValueChange?: (value: string | null) => void;
};
export const SelectDeal: React.FC<SelectDealProps> = (props) => {
	const disabled = props.disabled ?? false;
	const className = props.className ?? "";
	const hasNew = props.hasNew ?? true;
	const hasNotSelected = props.hasNotSelected ?? false;
	const componentName = "deal";
	const checkoutFormState = useCheckoutFormState();
	const translate = useTranslate();

	const items: Deal[] = [];
	if (hasNew) {
		items.push({
			DealId: "-",
			Deal: `(${translate("New Job")})`,
		});
	}
	if (hasNotSelected) {
		items.push({
			DealId: "",
			Deal: `(Not Selected)`,
		});
	}
	items.push(...(checkoutFormState.get().deals ?? []));

	const storefrontSettingsState = useStorefrontSettingsState();
	const isUniversity =
		storefrontSettingsState.get().settings?.IsUniversity ?? false;
	let caption = "";
	caption = translate("Job");
	if (isUniversity) {
		caption = translate("Class");
	}
	const selectedValue = checkoutFormState.get().dealIdValue ?? "";
	const selectedDealLabel =
		items.find((item) => item.DealId === selectedValue)?.Deal ?? "";
	//if (checkoutFormState.get().warehouseIdValue && (checkoutFormState.get().lookupwarehouse?.length ?? 0)) {
	//    selectedValue = checkoutFormState.get().dealIdValue ?? '';
	//}

	return (
		<div className={cn("w-full", className)}>
			<Label htmlFor={`${componentName}-select`} className="mb-1">
				{caption}
			</Label>
			<Select
				id={`${componentName}-select`}
				disabled={disabled}
				onValueChange={async (value) => {
					const dealid = value || "";
					checkoutFormState.setSelectedDealId(dealid);
					checkoutFormState.setJobName("");
					if (props.onValueChange) {
						props.onValueChange(value);
					}
				}}
				value={selectedValue}
			>
				<SelectTrigger className="h-8 w-full">
					<SelectValue>{selectedDealLabel}</SelectValue>
				</SelectTrigger>
				<SelectContent>
					<SelectGroup>
						{items.map((deal) => {
							return (
								<SelectItem key={deal.DealId} value={deal.DealId}>
									{deal.Deal}
								</SelectItem>
							);
						})}
					</SelectGroup>
				</SelectContent>
			</Select>
		</div>
	);
};
